import React, { createContext, useContext, useEffect, useState } from 'react';
import * as signalR from '@microsoft/signalr';
import { getAPIMKey, getInvestorBeaconUrl } from '../../utils/config';

// Define types for the SignalR connection
interface SignalRContextType {
  connection: signalR.HubConnection | null;
  isConnecting: boolean;
}
// Create a context for the SignalR connection
const SignalRContext = createContext<SignalRContextType | null>(null);
interface SignalRProviderProps {
  children: React.ReactNode; // Explicitly typing children
}
export const SignalRProvider: React.FC<SignalRProviderProps> = ({ children }) => {
  const [connection, setConnection] = useState<signalR.HubConnection | null>(null);
  const [isConnecting, setIsConnecting] = useState(true);
  const beaconUrl = getInvestorBeaconUrl();


  useEffect(() => {
    const connectToHub = async () => {
      if (beaconUrl) {
        const newConnection = new signalR.HubConnectionBuilder()
        .withUrl(`${beaconUrl}/auctionhub?subscription-key=${getAPIMKey()}`)
        .configureLogging(signalR.LogLevel.Information)
        .withAutomaticReconnect([0, 1000, 2000, 10000, 30000, 40000, 60000, 80000, 100000]) // Retry intervals (0ms, 2s, 10s, 30s)
        .withHubProtocol(new signalR.JsonHubProtocol()) // Ensure you're using the correct protocol
        .withServerTimeout(60000) // Increase timeout to 60 seconds (or as needed)
        .build();

        try {
          await newConnection.start();
          setConnection(newConnection);
          console.log(newConnection, 'newConnection')
          // Handle connection events
          newConnection.onclose(() => console.log('Connection closed'));
          newConnection.onreconnected(() => console.log('Connection reestablished'));
          newConnection.onreconnecting(() => console.log('Reconnecting...'));
        } catch (error) {
          console.error('Error connecting to the hub:', error);
        } finally {
          setIsConnecting(false);
        }
      }

    };

    connectToHub();

    // Cleanup connection on unmount
    return () => {
      if (connection) connection.stop();
    };
  }, []);

  return (
    <SignalRContext.Provider value={{ connection, isConnecting }}>
      {children}
    </SignalRContext.Provider>
  );
};

// Custom hook to use the SignalR connection
export const useSignalR = () => {
  return useContext(SignalRContext);
};
